export const STATUS_COLOR = {
  "Закрыта": "#16a34a",
  "Открыта": "#2563eb",
  "Не доставлено": "#ef4444",
};
export const colorByStatus = (s) => STATUS_COLOR[s] || "#6b7280";

export const fmtTime = (v) => {
  const d = v ? new Date(v) : null;
  return d && !isNaN(d)
    ? d.toLocaleTimeString("ru-RU", { hour: "2-digit", minute: "2-digit" })
    : "—";
};
export const toHour = (d) => d.getHours() + d.getMinutes() / 60;
export const clamp = (n, a, b) => Math.max(a, Math.min(b, n));

export const getScanTime = (r) => {
  if (!r) return null;
  if (r.marks_changed_at) {
    const d = new Date(r.marks_changed_at);
    if (!isNaN(d)) return d;
  }
  if (r.updated_at) {
    const d = new Date(r.updated_at);
    if (!isNaN(d)) return d;
  }
  return null;
};
export const getStatusTime = (r) => {
  if (!r?.status_changed_at) return null;
  const d = new Date(r.status_changed_at);
  return isNaN(d) ? null : d;
};
